import { render } from "./DealsPage.vue?vue&type=template&id=6ca9d0c4&ts=true"
import script from "./DealsPage.vue?vue&type=script&lang=ts"
export * from "./DealsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__